// extracted by mini-css-extract-plugin
export default {"iconContainer":"Clubs-Change-Description_iconContainer__aCcE-","button":"Clubs-Change-Description_button__hFO6Z","wrapContainer":"Clubs-Change-Description_wrapContainer__Lta+s"};